import './PinPage.css';

function PinPage({ className, children }) {
  return (
    <section className={['pin-page', className].filter(Boolean).join(' ')}>{children}</section>
  );
}

export default PinPage;
